const initialState = {
    isAssignedTab: false,
    includeClosedOlderThan60Days: false,
    responseLead: null,
    groups: {},
    whatsapp: {
        id: null,
        lead_id: null,
        lead: null,
        show_calling_modal: false,
        client_id: null,
        user_id: null,
        chat: [],
        events_payload: [],
        profile_data: null,
        createdAt: null,
        createdBy: null,
        updatedAt: null,
        updatedBy: null,
        deletedAt: null,
        deletedBy: null
    },
}

export default initialState
